export const formattedPathKey = (pathname, clientProfilePath) =>
  pathname.slice(clientProfilePath.length + 1).replace(/[-/]/g, '_');
